import React from 'react';
// Data
import { favoriteSessionsArray } from '../../utils/data/ServicesData';
// Images
import FullMainImage from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots.jpg';

export default function FavouriteServices() {
  return (
    <section className='grid w-full'>
      <div className='grid gap-6 md:gap-10 lg:gap-16 px-6 sm:px-10 md:px-24'>
        {/* Header */}
        <section className='grid text-center'>
          <div>
            <p
              className={`font-bold font-StencilW01 tracking-widest text-3xl sm:text-4xl md:text-6xl`}
            >
              MY FAVOURITE KINKS
            </p>
          </div>
        </section>

        {/* Grid Layout */}
        <section className='grid'>
          <section className='grid'>
            <div className='grid gap-6 lg:grid-cols-[1fr_auto_1fr]'>
              {/* Left Column */}
              <div className='grid gap-6'>
                {favoriteSessionsArray.slice(0, 3).map((session) => (
                  <SessionCard key={session.title} session={session} />
                ))}
              </div>

              {/* Center Image (Only on large screens) */}
              <div className='hidden lg:flex items-center'>
                <img
                  src={FullMainImage}
                  alt='Mistress Raven'
                  className='w-64 rounded-lg shadow-lg'
                />
              </div>

              {/* Right Column */}
              <div className='grid gap-6'>
                {favoriteSessionsArray.slice(3, 6).map((session) => (
                  <SessionCard key={session.title} session={session} />
                ))}
              </div>
            </div>
            <div className='grid justify-center mx-auto gap-6 pt-6'>
              {favoriteSessionsArray.slice(6, 8).map((session) => (
                <SessionCard key={session.title} session={session} />
              ))}
            </div>
          </section>
        </section>
      </div>
    </section>
  );
}

// Individual Session Card
const SessionCard = ({ session }) => {
  return (
    <article className='grid gap-2 bg-colour2 text-colour1 border-solid border-2 border-colour4 p-4 rounded-lg shadow-cardShadow shadow-colour4 text-center '>
      <div className='grid h-fit my-auto'>
        <div>
          <h3 className='text-xl font-semibold font-StencilW01'>
            {session.title}
          </h3>
        </div>
        <div>
          <p className='text-colour5'>{session.description}</p>
        </div>
      </div>
    </article>
  );
};
